// useSetupApiAuth.ts
import { useEffect } from 'react';
import { useClerkAuth } from '@/clerk.config';
import { setAuthTokenGetter } from '@/api/apiConfig';

export const useSetupApiAuth = () => {
  const { getToken } = useClerkAuth();

  useEffect(() => {
    setAuthTokenGetter(async () => await getToken());
  }, [getToken]);
};
